export const GTM_ID = "GTM-MK7BXTCV";

function isAllowedHost(hostname) {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "yogappify.com" ||
    hostname === "www.yogappify.com" ||
    hostname === "app.yogappify.com"
  );
}

export function loadGTMOnce() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__yogappifyGtmLoaded) return;

  const hostname = window.location?.hostname || "";
  if (!isAllowedHost(hostname)) return;
  if (!GTM_ID) return;

  window.__yogappifyGtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}
